import { AccountTable } from 'components';
import React from 'react';
import { UiAccountPage } from './AccountPage.style';


/**
 * 帳號列表頁面
 */

export const AccountPage = () => {
  return (
    <UiAccountPage>
      <AccountTable />
    </UiAccountPage>
  );
};


